import { useRef, createContext, useContext, useMemo, useEffect } from "react";
import { connect } from "react-redux";
// components
import SapPoDataContainer from "../../containers/SapPoDataContainer";
import DashboardHeader from "./DashboardHeader";
import DashboardContent from "./DashboardContent";
import DashboardLoading from "./DashboardLoading";
// provider
import { useAppAutenticationContext } from "../../msal/MsalAppAuthenticationProvider";
// actions
import {
  setLoading,
  setLayout,
  fetchClaimCountTask,
  fetchOrderTask,
  fetchTosTask,
  fetchListTosTask,
} from "../../actions/layout";
import { setAccountData } from "../../actions/account";
/* --------------------------------- Context -------------------------------- */

const DashboardLayoutContext = createContext({
  setLoading: null,
});

export const useDashboardLayoutContext = () =>
  useContext(DashboardLayoutContext);

/* -------------------------------- Component ------------------------------- */

function DashbordLayout({ dispatch, layout, children }) {
  /* ----------------------------------- Ref ---------------------------------- */
  const currentLoadingState = useRef(true);
  const isMounted = useRef(true);
  /* ---------------------------------- Hooks --------------------------------- */
  const { accountInfo, logout } = useAppAutenticationContext();

  /* ----------------------------- Handle Unmount ----------------------------- */
  useEffect(() => {
    dispatch(fetchTosTask());
    dispatch(fetchClaimCountTask());
    dispatch(fetchOrderTask());
    dispatch(fetchListTosTask());

    return () => {
      isMounted.current = false;
    };
  }, []);

  /* ----------------- Handler Update Redux State AccountInfo ----------------- */
  useEffect(() => {
    dispatch(
      setAccountData({
        UserName: accountInfo.username,
        Roles: accountInfo.roles,
        fetched: true,
      })
    );
  }, [accountInfo, dispatch]);

  /* --------------------- Handler Click Collapes Sidebar Menu --------------------- */
  const handlerClickCollapse = (el) => () => {
    if (el === "isActiveSidebar") {
      //when in mobile scroll to top
      document.getElementsByClassName("layout")[0].scrollTop = 0;
    }

    dispatch(
      setLayout({
        ...layout,
        [el]: !layout[el],
      })
    );
  };

  /* --------------------------- SetLoading Context --------------------------- */
  const dashboardContextValue = useMemo(() => {
    return {
      setLoading: handlerSetLoading,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <DashboardLoading
        isHide={layout.isHide}
        isLoading={layout.isLoading}
        username={accountInfo.username}
      />
      <SapPoDataContainer />
      <div
        className={`layout ${
          !layout.isActiveSidebarSm ? "layout-sidebar-collapsed" : ""
        }`}
      >
        <DashboardHeader
          onClickCollapse={handlerClickCollapse}
          displayName={accountInfo.displayName}
          logout={logout}
        />
        <DashboardContent page={layout.page}>
          <DashboardLayoutContext.Provider value={dashboardContextValue}>
            {children}
          </DashboardLayoutContext.Provider>
        </DashboardContent>
      </div>
    </>
  );

  /* ------------------------------- Set Loading ------------------------------ */
  function handlerSetLoading(open) {
    currentLoadingState.current = open;
    if (open) {
      dispatch(
        setLayout({
          isLoading: true,
          isHide: false,
        })
      );
    } else {
      dispatch(setLoading(false));

      setTimeout(() => {
        if (isMounted.current && !currentLoadingState.current)
          dispatch(
            setLayout({
              isHide: true,
            })
          );
      }, 500);
    }
  }
}

export default connect((state) => ({
  layout: state.layout,
}))(DashbordLayout);
